export const AUTH_TOKEN_PARAM = 'access_token';
export const AUTH_HEADER = 'Authorization';
export const API_KEY_FIELD = 'X-API-KEY';
export const PARTNER_ID_HEADER = 'X-Partner-ID';
